import React, { useState } from "react";
import PropTypes from "prop-types";
import LoginForm from "./login";
import RegisterForm from "./register";
import { databaseConnection } from "../../shared/constants";
import "./index.css";

export const Form = (props) => {
  const { formType } = props;
  const [userName, setUserName] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  return formType === "login" ? (
    <LoginForm
      databaseConnection={databaseConnection}
      username={userName}
      successMessage={successMessage}
      {...props}
    />
  ) : (
    <RegisterForm
      databaseConnection={databaseConnection}
      setUserName={setUserName}
      setSuccessMessage={setSuccessMessage}
      {...props}
    />
  );
};

Form.propTypes = {
  formType: PropTypes.oneOf(["login", "register"]).isRequired,
};

export default Form;
